import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { AppState } from '../../../core.state';
import { NotificationService } from '../../../notifications/notification.service';
import { LanguageService } from '../../language/language.service';
import * as LanguageActions from './language.actions';

@Injectable()
export class LanguageEffects {


  constructor(
    private service: LanguageService,
    private actions$: Actions,
    private store: Store<AppState>,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private router: Router,
    private location: Location) {
  }

  @Effect()
  loadUsers$ = this.actions$.pipe(
    ofType(LanguageActions.LanguageActionTypes.LoadLanguages),
    mergeMap(_ =>
      this.service.getAll().pipe(
        map(items => (new LanguageActions.LoadLanguagesSuccess(items))),
        catchError(err => of(new LanguageActions.LoadLanguagesFail(err)))
      )
    )
  );

}
